'use strict';

const BeforeAfterSlider = () => {
  const sliders = document.querySelectorAll('.image_before_after');
  
  // image_before_afterクラスが存在しない場合は処理を終了
  if (sliders.length === 0) {
    return;
  }
  
  // 既に初期化済みのスライダーをスキップするため、初期化済みフラグをチェック
  const uninitializedSliders = Array.from(sliders).filter(slider => !slider.dataset.initialized);
  
  uninitializedSliders.forEach(function(slider) {
    // sliderがnullの場合はスキップ
    if (!slider) {
      return;
    }
    
    const beforeImage = slider.querySelector('.image_before');
    const afterImage = slider.querySelector('.image_after');
    
    // 必要な要素が存在しない場合はスキップ
    if (!beforeImage || !afterImage) {
      return;
    }
    
    // 初期化済みフラグを設定
    slider.dataset.initialized = 'true';
    
    const handle = document.createElement('div');
    handle.className = 'slider-handle';
    slider.appendChild(handle);
    
    let isDragging = false;
    let startX, startLeft;
    
    // マウスイベント
    handle.addEventListener('mousedown', startDragging);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDragging);
    
    // タッチイベント（モバイル対応）
    handle.addEventListener('touchstart', startDragging);
    document.addEventListener('touchmove', drag);
    document.addEventListener('touchend', stopDragging);
    
    // 初期位置設定
    updateSlider(50);
    
    function startDragging(e) {
      isDragging = true;
      e.preventDefault();
      
      if (e.type === 'mousedown') {
        startX = e.clientX;
      } else if (e.type === 'touchstart') {
        startX = e.touches[0].clientX;
      }
      
      startLeft = parseFloat(getComputedStyle(handle).left);
    }
    
    function drag(e) {
      if (!isDragging) return;
      e.preventDefault();
      
      let currentX;
      if (e.type === 'mousemove') {
        currentX = e.clientX;
      } else if (e.type === 'touchmove') {
        currentX = e.touches[0].clientX;
      }
      
      const deltaX = currentX - startX;
      const sliderRect = slider.getBoundingClientRect();
      const newLeft = startLeft + deltaX;
      
      const percentage = Math.max(0, Math.min(100, (newLeft / sliderRect.width) * 100));
      updateSlider(percentage);
    }
    
    function stopDragging() {
      isDragging = false;
    }
    
    function updateSlider(percentage) {
      handle.style.left = percentage + '%';
      afterImage.style.clipPath = `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`;
    }
    
    // キーボード操作対応
    slider.addEventListener('keydown', function(e) {
      const currentPercentage = parseFloat(handle.style.left);
      let newPercentage;
      
      switch(e.key) {
        case 'ArrowLeft':
          newPercentage = Math.max(0, currentPercentage - 5);
          break;
        case 'ArrowRight':
          newPercentage = Math.min(100, currentPercentage + 5);
          break;
        default:
          return;
      }
      
      updateSlider(newPercentage);
    });
    
    // フォーカス可能にする
    slider.setAttribute('tabindex', '0');
  });
};

// グローバルにアクセス可能にする
window.reinitializeBeforeAfterSliders = BeforeAfterSlider;

export default BeforeAfterSlider; 